import React from "react";
import Headline from "./Headline";
import { notification } from "antd";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import HomeLink from "../../widgets/HomeLink";
import { Link, useParams, useSearchParams } from "react-router-dom";
import PostsApi from "../../api-services/posts-api.service";

const bannerPath = '/iceholidays-assets/images/gd_classic.png';

const _posts = {
  "world": "GD World Cruises",
  "fly": "GD FlyCruise",
  "domestic": "GD Domestic",
  "flight": "GD Flight",
  "trip": "G-Trip"
}

function withParams(Component) {
  return props => <Component {...props} params={useParams()} searchParams={useSearchParams()}/>;
}

class PostsShowPage extends React.Component <{params, searchParams}>  {
  postsApi = new PostsApi;

  state = {
    post: {title: "", thumbnail: "", content: ""},
    breadcrumbs: []
  }

  componentDidMount() {
    const type = this.props.params.type;
    this.postsApi.getPost(this.props.params.id)
      .then(blogData => {
        const breadcrumbs = [
          { title: <HomeLink/>},
          { title: <Link to={`/web/posts/${type}`}>{_posts[type]}</Link> },
          { title: <span>{blogData.title}</span> }
        ];

        this.setState({post: blogData, breadcrumbs})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading post.'});
      });
  }


  render(){
    const {post} = this.state;
    return (
      <div id="gd-posts-show" className="gd-series-tour-page">
        <Headline showSearch={false} bannerImage={post.thumbnail || bannerPath} breadcrumbs={this.state.breadcrumbs}>
          <span className="title">
            {post.title}
          </span>
        </Headline>

        <div className="gd-series-tour-show-page_body">          
          <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{post.content}</Markdown>
        </div>

      </div>
    )
  }
}

export default withParams(PostsShowPage);